module.exports = __webpack_public_path__ + "img/微信支付.13402576.png";